import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, withKeys as _withKeys, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
    class: "form",
    show: "loaded"
};
const _hoisted_2 = { class: "form-details" };
const _hoisted_3 = { class: "form-details" };
const _hoisted_4 = /*#__PURE__*/ _createElementVNode("div", { class: "form-title" }, [
    /*#__PURE__*/ _createElementVNode("h2", null, "\r\n\t\t\t\t\t\tSMTP Importer Settings\r\n\t\t\t\t\t")
], -1 /* HOISTED */);
const _hoisted_5 = { class: "form-menu" };
const _hoisted_6 = { class: "float-end" };
const _hoisted_7 = /*#__PURE__*/ _createElementVNode("span", { class: "fa fa-plus" }, null, -1 /* HOISTED */);
const _hoisted_8 = /*#__PURE__*/ _createElementVNode("span", { class: "hidden-xs" }, " Add Rule", -1 /* HOISTED */);
const _hoisted_9 = { class: "form-contents" };
const _hoisted_10 = { class: "row" };
const _hoisted_11 = { class: "clearfix" };
const _hoisted_12 = { class: "col-xs-12 col-sm-12 col-md-4" };
const _hoisted_13 = { class: "input-group top_search" };
const _hoisted_14 = { class: "input-group-btn" };
const _hoisted_15 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-search" }, null, -1 /* HOISTED */);
const _hoisted_16 = [
    _hoisted_15
];
const _hoisted_17 = { class: "col-xs-12 col-sm-12 col-md-8" };
const _hoisted_18 = { class: "d-flex float-end" };
const _hoisted_19 = /*#__PURE__*/ _createElementVNode("label", { class: "mt-2 mb-0 me-2" }, "Check Inbox From:", -1 /* HOISTED */);
const _hoisted_20 = /*#__PURE__*/ _createElementVNode("div", { class: "input-group-append input-group-btn" }, [
    /*#__PURE__*/ _createElementVNode("button", {
        type: "button",
        class: "btn btn-default",
        "data-toggle": ""
    }, [
        /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-calendar" })
    ])
], -1 /* HOISTED */);
const _hoisted_21 = { class: "col-xs-12 col-sm-12" };
const _hoisted_22 = { class: "card bg-white data-grid detached overflow-x-auto" };
const _hoisted_23 = { class: "table table-hover bottom0 pw100" };
const _hoisted_24 = /*#__PURE__*/ _createElementVNode("thead", null, [
    /*#__PURE__*/ _createElementVNode("tr", null, [
        /*#__PURE__*/ _createElementVNode("th", { class: "min-width100 w200" }, "\r\n\t\t\t\t\t\t\t\t\t\tFilter Location\r\n\t\t\t\t\t\t\t\t\t"),
        /*#__PURE__*/ _createTextVNode(),
        /*#__PURE__*/ _createElementVNode("th", { class: "min-width300 w300" }, "\r\n\t\t\t\t\t\t\t\t\t\tKey Word\r\n\t\t\t\t\t\t\t\t\t"),
        /*#__PURE__*/ _createTextVNode(),
        /*#__PURE__*/ _createElementVNode("th", { class: "min-width300 w300" }, "\r\n\t\t\t\t\t\t\t\t\t\tMailbox\r\n\t\t\t\t\t\t\t\t\t"),
        /*#__PURE__*/ _createTextVNode(),
        /*#__PURE__*/ _createElementVNode("th", { class: "min-width300" }, "\r\n\t\t\t\t\t\t\t\t\t\tCompany\r\n\t\t\t\t\t\t\t\t\t"),
        /*#__PURE__*/ _createTextVNode(),
        /*#__PURE__*/ _createElementVNode("th", { class: "min-width300" }, "\r\n\t\t\t\t\t\t\t\t\t\tSite\r\n\t\t\t\t\t\t\t\t\t"),
        /*#__PURE__*/ _createTextVNode(),
        /*#__PURE__*/ _createElementVNode("th", { class: "text-center" }, "\r\n\t\t\t\t\t\t\t\t\t\tDisabled\r\n\t\t\t\t\t\t\t\t\t")
    ])
], -1 /* HOISTED */);
const _hoisted_25 = { class: "invalid-feedback" };
const _hoisted_26 = { class: "text-center align-middle" };
const _hoisted_27 = {
    class: "d-flex justify-content-center align-items-center",
    style: { "height": "100%" }
};
const _hoisted_28 = { class: "text-end" };
const _hoisted_29 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-save" }, null, -1 /* HOISTED */);
const _hoisted_30 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-trash" }, null, -1 /* HOISTED */);
const _hoisted_31 = { key: 0 };
const _hoisted_32 = /*#__PURE__*/ _createElementVNode("tr", null, [
    /*#__PURE__*/ _createElementVNode("td", {
        class: "text-center",
        colspan: "4"
    }, [
        /*#__PURE__*/ _createElementVNode("h5", null, "\r\n\t\t\t\t\t\t\t\t\t\t\tThere are no records matching your criteria.\r\n\t\t\t\t\t\t\t\t\t\t")
    ])
], -1 /* HOISTED */);
const _hoisted_33 = [
    _hoisted_32
];
const _hoisted_34 = { class: "data-grid-footer clearfix detached pw100" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_b_button = _resolveComponent("b-button");
    const _component_b_form_input = _resolveComponent("b-form-input");
    const _component_flat_pickr = _resolveComponent("flat-pickr");
    const _component_b_input_group_append = _resolveComponent("b-input-group-append");
    const _component_b_input_group = _resolveComponent("b-input-group");
    const _component_b_form_select = _resolveComponent("b-form-select");
    const _component_b_form_checkbox = _resolveComponent("b-form-checkbox");
    const _component_b_pagination = _resolveComponent("b-pagination");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
                _hoisted_4,
                _createTextVNode(),
                _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                        _createVNode(_component_b_button, {
                            variant: "primary",
                            onClick: _ctx.add
                        }, {
                            default: _withCtx(() => [
                                _hoisted_7,
                                _hoisted_8
                            ]),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["onClick"])
                    ])
                ])
            ])
        ]),
        _createTextVNode(),
        _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("div", _hoisted_13, [
                            _createVNode(_component_b_form_input, {
                                type: "text",
                                modelValue: _ctx.query.keywords,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.query.keywords) = $event)),
                                modelModifiers: { trim: true },
                                placeholder: "Search for...",
                                onKeyup: _withKeys(_ctx.search, ["enter"]),
                                required: ""
                            }, null, 8 /* PROPS */, ["modelValue", "onKeyup"]),
                            _createTextVNode(),
                            _createElementVNode("span", _hoisted_14, [
                                _createElementVNode("button", {
                                    type: "button",
                                    class: "btn btn-default",
                                    onClick: _cache[1] || (_cache[1] =
                                        //@ts-ignore
                                        (...args) => (_ctx.search && _ctx.search(...args)))
                                }, _hoisted_16)
                            ])
                        ])
                    ]),
                    _createTextVNode(),
                    _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("div", _hoisted_18, [
                            _createVNode(_component_b_input_group, {
                                class: _normalizeClass(['top_search'])
                            }, {
                                default: _withCtx(() => [
                                    _hoisted_19,
                                    _createTextVNode(),
                                    _createVNode(_component_flat_pickr, {
                                        class: "form-control",
                                        modelValue: _ctx.lastDateTime,
                                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.lastDateTime) = $event)),
                                        config: _ctx.datePickerConfig,
                                        placeholder: "date"
                                    }, null, 8 /* PROPS */, ["modelValue", "config"]),
                                    _createTextVNode(),
                                    _createVNode(_component_b_input_group_append, null, {
                                        default: _withCtx(() => [
                                            _hoisted_20
                                        ]),
                                        _: 1 /* STABLE */
                                    })
                                ]),
                                _: 1 /* STABLE */
                            })
                        ])
                    ])
                ]),
                _createTextVNode(),
                _withDirectives(_createElementVNode("div", _hoisted_21, [
                    _createElementVNode("div", _hoisted_22, [
                        _createElementVNode("table", _hoisted_23, [
                            _hoisted_24,
                            _createTextVNode(),
                            _createElementVNode("tbody", null, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.records, (item) => {
                                    return (_openBlock(), _createElementBlock("tr", null, [
                                        _createElementVNode("td", null, [
                                            _createVNode(_component_b_form_select, {
                                                modelValue: item.keyWordLocation,
                                                "onUpdate:modelValue": ($event) => ((item.keyWordLocation) = $event),
                                                options: _ctx.keyWordlocations
                                            }, null, 8 /* PROPS */, ["modelValue", "onUpdate:modelValue", "options"])
                                        ]),
                                        _createTextVNode(),
                                        _createElementVNode("td", null, [
                                            _createVNode(_component_b_form_input, {
                                                type: "text",
                                                modelValue: item.keyWord,
                                                "onUpdate:modelValue": ($event) => ((item.keyWord) = $event),
                                                modelModifiers: { trim: true },
                                                class: _normalizeClass({ 'is-invalid': !item.keyWord }),
                                                maxlength: "250"
                                            }, null, 8 /* PROPS */, ["modelValue", "onUpdate:modelValue", "class"]),
                                            _createTextVNode(),
                                            _withDirectives(_createElementVNode("div", _hoisted_25, "\r\n\t\t\t\t\t\t\t\t\t\t\tThe Key Word field is required.\r\n\t\t\t\t\t\t\t\t\t\t", 512 /* NEED_PATCH */), [
                                                [_vShow, !item.headerContent]
                                            ])
                                        ]),
                                        _createTextVNode(),
                                        _createElementVNode("td", null, [
                                            _createVNode(_component_b_form_input, {
                                                type: "text",
                                                modelValue: item.mailbox,
                                                "onUpdate:modelValue": ($event) => ((item.mailbox) = $event),
                                                modelModifiers: { trim: true },
                                                maxlength: "250",
                                                title: "Mailbox that the rule will be applied. If more than one, separate with \";\". Leave empty to apply to all mailboxes."
                                            }, null, 8 /* PROPS */, ["modelValue", "onUpdate:modelValue"])
                                        ]),
                                        _createTextVNode(),
                                        _createElementVNode("td", null, [
                                            _createVNode(_component_b_form_select, {
                                                modelValue: item.companyId,
                                                "onUpdate:modelValue": ($event) => ((item.companyId) = $event),
                                                options: _ctx.companies
                                            }, null, 8 /* PROPS */, ["modelValue", "onUpdate:modelValue", "options"])
                                        ]),
                                        _createTextVNode(),
                                        _createElementVNode("td", null, [
                                            _createVNode(_component_b_form_select, {
                                                modelValue: item.siteId,
                                                "onUpdate:modelValue": ($event) => ((item.siteId) = $event),
                                                options: _ctx.sites(item.companyId)
                                            }, null, 8 /* PROPS */, ["modelValue", "onUpdate:modelValue", "options"])
                                        ]),
                                        _createTextVNode(),
                                        _createElementVNode("td", _hoisted_26, [
                                            _createElementVNode("div", _hoisted_27, [
                                                _createVNode(_component_b_form_checkbox, {
                                                    modelValue: item.disabled,
                                                    "onUpdate:modelValue": ($event) => ((item.disabled) = $event),
                                                    size: "lg"
                                                }, null, 8 /* PROPS */, ["modelValue", "onUpdate:modelValue"])
                                            ])
                                        ]),
                                        _createTextVNode(),
                                        _createElementVNode("td", _hoisted_28, [
                                            _createVNode(_component_b_button, {
                                                type: "button",
                                                variant: "primary",
                                                onClick: ($event) => (_ctx.save(item))
                                            }, {
                                                default: _withCtx(() => [
                                                    _hoisted_29
                                                ]),
                                                _: 2 /* DYNAMIC */
                                            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"]),
                                            _createTextVNode(),
                                            _createVNode(_component_b_button, {
                                                type: "button",
                                                variant: "primary",
                                                onClick: ($event) => (_ctx.purge(item))
                                            }, {
                                                default: _withCtx(() => [
                                                    _hoisted_30
                                                ]),
                                                _: 2 /* DYNAMIC */
                                            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"])
                                        ])
                                    ]));
                                }), 256 /* UNKEYED_FRAGMENT */))
                            ]),
                            _createTextVNode(),
                            (_ctx.noData)
                                ? (_openBlock(), _createElementBlock("tfoot", _hoisted_31, _hoisted_33))
                                : _createCommentVNode("v-if", true)
                        ])
                    ]),
                    _createTextVNode(),
                    _createElementVNode("div", _hoisted_34, [
                        _createVNode(_component_b_pagination, {
                            class: "float-end",
                            modelValue: _ctx.query.pageNo,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_ctx.query.pageNo) = $event)),
                            "per-page": _ctx.query.pageSize,
                            "total-rows": _ctx.data.recordCount,
                            "hide-ellipsis": true,
                            disabled: _ctx.working
                        }, null, 8 /* PROPS */, ["modelValue", "per-page", "total-rows", "disabled"])
                    ])
                ], 512 /* NEED_PATCH */), [
                    [_vShow, _ctx.searchAttempted]
                ])
            ])
        ])
    ]));
}
